import React from 'react';
import { ToastNotification, Box, Typography } from '@drone-js/core';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsVisible, hideNotification, selectText } from 'store/slice/notification';
import { Breakpoint, selectBreakpoint } from 'store/slice/screen';
import { MarginType } from '@drone-js/theme';

export interface ActToastNotificationProps {
    dismissible?: boolean;
    description?: string;
}

interface MarginUnitType {
    ms: MarginType;
    me: MarginType;
    my: MarginType;
}

type BreakPointUnitType = keyof (Breakpoint & { s: 's' });

const MarginUnits: Record<BreakPointUnitType, MarginUnitType> = {
    xl: {
        ms: '0',
        me: '48',
        my: '48',
    },
    l: {
        ms: '0',
        me: '48',
        my: '48',
    },
    m: {
        ms: '0',
        me: '48',
        my: '48',
    },
    s: {
        ms: '16',
        me: '16',
        my: '16',
    },
};

export const ActivitiesToastNotification: React.FC<ActToastNotificationProps> = (props) => {
    const { dismissible = true, description } = props;
    const dispatch = useDispatch();
    const isVisible = useSelector(selectIsVisible);

    const updatedDescription = useSelector(selectText);
    const breakPoint = useSelector(selectBreakpoint);
    const onDismiss = () => {
        dispatch(hideNotification());
    };

    const toastMarginUnits: MarginUnitType = React.useMemo(() => {
        if (breakPoint.xl) {
            return MarginUnits.xl;
        }

        if (breakPoint.l) {
            return MarginUnits.l;
        }

        if (breakPoint.m) {
            return MarginUnits.m;
        }

        return MarginUnits.s;
    }, [breakPoint]);

    if (!isVisible) {
        return null;
    }

    return (
        <Box data-testid="act-toast-notification" width="340px" mx={toastMarginUnits.ms} me={toastMarginUnits.me} my={toastMarginUnits.my} position="sticky" bottom="0">
            <ToastNotification
                asset={{ id: 'fill.symbol.circle-info' }}
                intent="notice"
                dismissible={dismissible}
                description={
                    <Typography mx="8" tag="p" variant="body-s-strong">
                        {updatedDescription || description}
                    </Typography>
                }
                onClose={onDismiss}
            />
        </Box>
    );
};

ActivitiesToastNotification.displayName = 'ActivitiesToastNotification';
